// extracted by mini-css-extract-plugin
export default {"form":"AddBomForm_form__kivrY"};